import React from "react";

export const Paragraph: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <p className="py-3 subpixel-antialiased leading-relaxed tracking-wider text-gray-400 text-md">
      {children}
    </p>
  );
};
